import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import kebabCase from 'lodash/kebabCase';
import utils from './utils';

function normalizeComponent(Comp, params = {}, fallback = Comp) {
    if (typeof Comp === 'function') {
        if (Object.getPrototypeOf(Comp).isReactComponent) {
            return (
                <Comp {...params} />
            );
        }
        return Comp(params);
    }
    return (
        fallback
    );
}

class DataTableCell extends React.Component {
    constructor(props) {
        super(props);

        this.renderContent = this.renderContent.bind(this);
    }

    renderContent() {
        const {
            accessor, Cell, data, type,
        } = this.props;

        if (Cell) {
            return normalizeComponent(Cell, this.props);
        }
        if (type === 'scores' || type === 'descriptive') {
            const index = parseInt(accessor, 10);
            if (data.scores[index].scoreValue < 0) {
                return (
                    <strong style={{ color: '#00002a' }}>{React.isValidElement(data.scores[index].score) ? data.scores[index].score : 'N/A'}</strong>
                );
            } else if (data.scores[index].scoreValue < 25) {
                return (
                    <strong style={{ color: '#7f7f7f' }}>{data.scores[index].score}</strong>
                );
            } else if (data.scores[index].scoreValue < 50) {
                return (
                    <strong style={{ color: '#009ed0' }}>{data.scores[index].score}</strong>
                );
            } else if (data.scores[index].scoreValue < 75) {
                return (
                    <strong style={{ color: '#004baf' }}>{data.scores[index].score}</strong>
                );
            }
            return (
                <strong style={{ color: '#00002a' }}>{data.scores[index].score}</strong>
            );
        } else if (type === 'profileScore') {
            let text;
            if (typeof data.profileScore === 'number') {
                text = data.profileScore > 0 ? data.profileScore : 'N/A';
            } else {
                text = data.profileScore;
            }
            return (
                <strong style={{ color: '#00002a' }}>{text}</strong>
            );
        }

        return (
            data[accessor]
        );
    }

    render() {
        const {
            accessor,
            align,
            className,
            type,
        } = this.props;
        const selector = kebabCase(utils.normalizeAccessor(accessor));
        const cellClassName = classNames('data-table__cell', {
            [`data-table__cell--${align}`]: true,
            [`data-table__cell--${selector}`]: true,
        }, className);
        if (type === 'names_scores') {
            return (
                <td style={{ cursor: 'default' }} className={cellClassName}>
                    {this.renderContent()}
                </td>
            );
        }
        return (
            <td className={cellClassName}>
                {this.renderContent()}
            </td>
        );
    }
}

DataTableCell.propTypes = {
    accessor: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.string,
    ]).isRequired,
    align: PropTypes.oneOf(['center', 'left', 'right']),
    className: PropTypes.string,
    Cell: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
        PropTypes.string,
    ]),
    data: PropTypes.shape({}).isRequired,
    type: PropTypes.string,
};

DataTableCell.defaultProps = {
    align: 'left',
    className: '',
    Cell: null,
    type: '',
};

export default DataTableCell;
